import { EXPERIENCE_TYPEAHEAD_SEARCH_TYPES } from 'constants/experience'
import { EmptyArray } from 'lib/array/arrayUtils'

export function shouldUseStreamingPlaceTypeahead(
  showNaturalLanguageSearchSuggestions: boolean,
  placeTypes?: Array<App.SearchPlaceType>,
): boolean {
  // Identity check against the shared constant, not a content compare. Copied
  // arrays (spread/filter) must stay on HTTP, including trip planner.
  return showNaturalLanguageSearchSuggestions || placeTypes === EXPERIENCE_TYPEAHEAD_SEARCH_TYPES
}

export function getPlaceSelectSearchResults<T>(
  useStreamingTypeahead: boolean,
  streamingResults: Array<T> | undefined,
  traditionalResults: Array<T>,
): Array<T> {
  if (useStreamingTypeahead) return streamingResults ?? EmptyArray
  return traditionalResults
}
